/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
// import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { Card, Checkbox, Icon } from "@mui/material";
import { Autocomplete } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { addPricingGroup } from "network/service";
import { useTheme } from '@mui/material/styles';
import DataTable from "examples/Tables/DataTable";
import { getPriceList } from "network/service";
import { addPriceList } from "network/service";
import { updatePriceList } from "network/service";




export default function AddEditPriceListPopup(props) {
    const { showNotification } = useNotification();
    const [loading, setLoading] = useState(false);
    const [newField, setNewField] = useState({ name: "" });
    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const [vals, setVals] = useState([]);
    const theme = useTheme();
    const [prclist, setPriceList] = useState(null);

    const validate = () => {
        if (props.selTempl && props.selgrp && props.selCnt && props.selMode) {
            return true;
        }
        return false;
    };

    const Create = async () => {

        if (validate()) {
            try {
                setLoading(true);
                if (prclist?._id) {
                    await updatePriceList(prclist._id, {
                        pricing_template: props.selTempl._id,
                        country: props.selCnt._id,
                        pricing_group: props.selgrp._id,
                        pricing_mode: props.selMode._id,
                        rate: vals.map(Number),
                    });
                } else {
                    await addPriceList({
                        pricing_template: props.selTempl._id,
                        country: props.selCnt._id,
                        pricing_group: props.selgrp._id,
                        pricing_mode: props.selMode._id,
                        rate: vals.map(Number),
                    });
                }
                showNotification("success", "Success", "Pricing List Added Successfully");
                props.handlesuccess();
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        }
    };

    const formPricingRows = () => {
        let rows = [];
        if (props.selTempl) {
            for (let rs in vals) {
                let row = {
                    from: rs == 0 ? 0 : props.selTempl.calculation[rs - 1],
                    to: (rs == props.selTempl.calculation.length) ? "Above" : props.selTempl.calculation[rs],
                    uom: "Kg",
                    per: <Checkbox checked={(rs != props.selTempl.calculation.length) ? props.selTempl.config[rs] : true} disabled />,
                    rate: <MDInput
                        value={vals[rs]}
                        type="number"
                        fullWidth
                        onChange={(e) => {
                            let temp = [...vals];
                            temp[rs] = e.target.value;
                            setVals(temp);
                        }}
                    />,
                }
                rows.push(row);
            }
        }
        return rows;
    }

    useEffect(() => {
        if (props.selTempl && props.selgrp && props.selCnt && props.selMode) {
            getPriceList(`pricing_template=${props.selTempl._id}&pricing_group=${props.selgrp._id}&country=${props.selCnt._id}&pricing_mode=${props.selMode._id}`).then((resp) => {
                if (resp.data.length > 0) {
                    setVals(resp.data[0].rate);
                    setPriceList(resp.data[0]);
                }
                else {
                    if (props.selTempl) {
                        setVals(Array(props.selTempl.calculation.length + 1).fill(0));
                        setPriceList(null);
                    }
                    else {
                        setVals([]);
                        setPriceList(null);
                    }
                }
            }).catch((err) => {
                console.log(err);
            });
        } else if (props.selTempl.calculation) {
            setVals(Array(props.selTempl.calculation.length + 1).fill(0));
            setPriceList(null);
        }
        else {
            setVals([]);
            setPriceList(null);
        }
    }, [props.selTempl, props.selgrp, props.selCnt, props.selMode]);

    return (

        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >

            <Card sx={{}}>
                <MDBox  >
                    <DialogTitle>Add Pricing</DialogTitle>
                </MDBox>
                <DialogContent sx={{ minWidth: 500 }}>

                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} xl={12}>
                            <Autocomplete
                                disableClearable
                                style={{ flex: "7", margin: 10 }}
                                label="Template"
                                options={props.templates}
                                getOptionLabel={(option) => option.template_name || ''}
                                renderInput={(params) => <MDInput {...params} label="Template" />}
                                onChange={(event, newValue) => {
                                    props.setSelTempl(newValue);
                                }}
                                value={props.selTempl}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} xl={12}>
                            <Autocomplete
                                disableClearable
                                style={{ flex: "7", margin: 10 }}
                                label="Group"
                                options={props.groups}
                                getOptionLabel={(option) => option.name || ''}
                                renderInput={(params) => <MDInput {...params} label="Group" />}
                                onChange={(event, newValue) => {
                                    props.setSelGrp(newValue);
                                }}
                                value={props.selgrp}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} xl={12}>
                            <Autocomplete
                                style={{ flex: "7", margin: 10 }}
                                label="Country"
                                options={props.countries}
                                getOptionLabel={(option) => option.name || ''}
                                renderInput={(params) => <MDInput {...params} label="Country" />}
                                onChange={(event, newValue) => {
                                    props.setSelCnt(newValue);
                                }}
                                value={props.selCnt}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} xl={12}>
                            <Autocomplete
                                disableClearable
                                style={{ flex: "7", margin: 10 }}
                                label="Mode"
                                options={props.modes}
                                getOptionLabel={(option) => option.name || ''}
                                renderInput={(params) => <MDInput {...params} label="Mode" />}
                                onChange={(event, newValue) => {
                                    props.setSelMode(newValue);
                                }}
                                value={props.selMode}
                            />
                        </Grid>
                    </Grid>
                    <Grid item>
                        <DataTable
                            table={{
                                columns: [
                                    { Header: "From", accessor: "from", align: "left" },
                                    { Header: "To", accessor: "to", align: "center" },
                                    { Header: "Unit", accessor: "uom", align: "center" },
                                    { Header: "Per Kg", accessor: "per", align: "center" },
                                    { Header: "Rate", accessor: "rate", align: "center" },
                                ],
                                rows: formPricingRows(),
                            }}
                            showTotalEntries={false}
                            isSorted={false}
                            noEndBorder
                            entriesPerPage={false}
                            currentPageIndex={currentPageIndex}
                            setCurrentPageIndex={setCurrentPageIndex}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <MDButton variant="gradient" color="error" onClick={props.handleclose}
                        disabled={loading}>
                        <Icon>close</Icon>&nbsp;
                        Cancel
                    </MDButton>
                    <MDButton variant="gradient" color="success"
                        disabled={loading}
                        onClick={() => { Create() }}>
                        <Icon>save</Icon>&nbsp;
                        Save
                    </MDButton>
                </DialogActions>
            </Card>
        </Dialog>
    )
};
